module.exports = __webpack_public_path__ + "img/round3-iteration3-1.bf7248e6.png";